/*
  Accordion behaviour for the FAQ Accordion section.

  Self-contained on purpose: the theme's global script.js binds the older
  .faq-question accordion, but its first statement calls lucide.createIcons()
  and the Lucide library is never loaded, so that file throws before it reaches
  the accordion and never binds anything. This file depends on nothing else.

  Clicks are handled by delegation from the document, so sections re-rendered by
  the theme editor keep working without rebinding.
*/
(function () {
  var ITEM = '.faq-accordion-item';
  var TRIGGER = '.faq-accordion-trigger';
  var ANSWER = '.faq-accordion-answer';
  var OPEN_CLASS = 'is-open';

  if (window.arkFaqAccordion) return;
  window.arkFaqAccordion = true;

  function answerOf(item) {
    return item.querySelector(ANSWER);
  }

  /* Freeze the panel at its measured height so the transition has two numbers
     to move between; open panels are released to `none` afterwards so answers
     that reflow (a font swap, a resize) are never clipped. */
  function setHeight(item, open) {
    var answer = answerOf(item);
    if (!answer) return;

    if (open) {
      answer.style.maxHeight = answer.scrollHeight + 'px';
    } else {
      if (answer.style.maxHeight === 'none' || answer.style.maxHeight === '') {
        answer.style.maxHeight = answer.scrollHeight + 'px';
        answer.offsetHeight; // force a reflow so the next value animates
      }
      answer.style.maxHeight = '0px';
    }
  }

  function toggle(item, open) {
    var trigger = item.querySelector(TRIGGER);

    item.classList.toggle(OPEN_CLASS, open);
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    setHeight(item, open);
  }

  function closeSiblings(item) {
    var list = item.closest('.faq-accordion-list');
    if (!list || list.dataset.allowMultiple === 'true') return;

    var siblings = list.querySelectorAll(ITEM + '.' + OPEN_CLASS);
    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i] !== item) toggle(siblings[i], false);
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var trigger = target.closest(TRIGGER);
    if (!trigger) return;

    var item = trigger.closest(ITEM);
    if (!item) return;

    var open = !item.classList.contains(OPEN_CLASS);
    if (open) closeSiblings(item);
    toggle(item, open);
  });

  document.addEventListener(
    'transitionend',
    function (event) {
      if (event.propertyName !== 'max-height') return;

      var answer = event.target;
      if (!answer.classList || !answer.classList.contains('faq-accordion-answer')) return;

      var item = answer.closest(ITEM);
      if (item && item.classList.contains(OPEN_CLASS)) answer.style.maxHeight = 'none';
    },
    true
  );

  /* Items rendered open by the section get their inline height set here, and
     any open panel is re-measured when the layout changes width. */
  function sync() {
    var items = document.querySelectorAll(ITEM + '.' + OPEN_CLASS);
    for (var i = 0; i < items.length; i++) {
      var answer = answerOf(items[i]);
      if (answer) answer.style.maxHeight = 'none';
    }
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(sync, 150);
  });

  document.addEventListener('shopify:section:load', sync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
